'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _imagesloaded = require('imagesloaded');

var _imagesloaded2 = _interopRequireDefault(_imagesloaded);

var _mutationObserver = require('mutation-observer');

var _mutationObserver2 = _interopRequireDefault(_mutationObserver);

var _objectOmit = require('object-omit');

var _objectOmit2 = _interopRequireDefault(_objectOmit);

var _packery = require('packery');

var _packery2 = _interopRequireDefault(_packery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var propTypes = {
	children: {
		type: 'array'
	},
	component: {
		type: 'string'
	},
	instance: {
		type: 'function'
	},
	options: {
		type: 'object'
	}
};

var defaultProps = {
	component: 'div',
	instance: function instance() {},
	repaintEvents: {
		imageLoad: true,
		mutations: {
			childList: true,
			subtree: true
		},
		resize: true
	}
};

var repaint = function repaint(instance) {
	return instance && requestAnimationFrame(function () {
		return instance.layout();
	});
};
var repaintOnImageLoad = function repaintOnImageLoad(el, instance) {
	return (0, _imagesloaded2.default)(el, function () {
		return repaint(instance);
	});
};
var repaintOnResize = function repaintOnResize(instance) {
	return window.addEventListener('resize', function () {
		return repaint(instance);
	});
};

var repaintOnMutations = function repaintOnMutations(el, instance, props) {
	return new _mutationObserver2.default(function (mutations) {
		mutations.map(function () {
			return props.repaintEvents.imageLoad ? repaintOnImageLoad(el, instance) : repaint(instance);
		});
	}).observe(el, props.repaintEvents.mutations);
};

var repaintOnEvents = function repaintOnEvents(el, instance, props) {
	var repaintEvents = props.repaintEvents;

	repaint(instance);

	if (repaintEvents.imageLoad) {
		repaintOnImageLoad(el, instance, props);
	}
	if (repaintEvents.mutations) {
		repaintOnMutations(el, instance, props);
	}
	if (repaintEvents.resize) {
		repaintOnResize(instance);
	}
};

var afterRender = function afterRender(_ref, el) {
	var props = _ref.props;
	var instance = props.instance,
	    options = props.options;


	var previousInstance = _packery2.default.data(el);
	if (previousInstance) {
		previousInstance.reloadItems();
		instance(previousInstance);
		repaintOnEvents(el, previousInstance, props);
		return;
	}

	var packery = new _packery2.default(el, options);

	instance(packery);
	repaintOnEvents(el, previousInstance, props);
};

var shouldUpdate = function shouldUpdate(_ref2, nextProps) {
	var props = _ref2.props;
	return !(0, _deepEqual2.default)(props, nextProps);
};

var render = function render(_ref3) {
	var props = _ref3.props;
	var children = props.children,
	    component = props.component;

	return (0, _magicVirtualElement2.default)(component, (0, _objectOmit2.default)(props, Object.keys(propTypes)), children);
};

exports.default = { afterRender: afterRender, defaultProps: defaultProps, Packery: _packery2.default, propTypes: propTypes, render: render, shouldUpdate: shouldUpdate };
